export const timeToSeconds = (time) => {
    const parts = time.split(':');
    let seconds = 0;

    if (parts.length === 3) {
        // hh:mm:ss
        seconds += parseInt(parts[0]) * 3600; // horas a segundos
        seconds += parseInt(parts[1]) * 60;   // minutos a segundos
        seconds += parseInt(parts[2]);        // segundos
    } else if (parts.length === 2) {
        // mm:ss
        seconds += parseInt(parts[0]) * 60;   // minutos a segundos
        seconds += parseInt(parts[1]);        // segundos
    } else if (parts.length === 1) {
        // ss
        seconds += parseInt(parts[0]);        // segundos
    }

    return seconds;
}

const documentLang = () => document.documentElement.getAttribute('lang') || 'es';

export const userTimeZone = () => document.getElementById('datosGenerales')?.getAttribute('data-timezone') || undefined;

const formatTimestamp = (ts, options) => new Intl.DateTimeFormat(documentLang(), { ...options, timeZone: userTimeZone() }).format(new Date(ts * 1000));

const isCurrentYear = (ts) => formatTimestamp(ts, { year: 'numeric' }) === formatTimestamp(Date.now() / 1000, { year: 'numeric' });

export const timestampToShortDate = (ts) => {
    if (!ts) {
        return '';
    }
    return formatTimestamp(ts, { day: 'numeric', month: 'short', year: 'numeric' });
}

export const timestampToLongDate = (ts) => {
    if (!ts) {
        return '';
    }
    return formatTimestamp(ts, { day: 'numeric', month: 'long', ...(isCurrentYear(ts) ? {} : { year: 'numeric' }) });
}

export const timestampToFullDate = (ts) => {
    if (!ts) {
        return '';
    }
    return formatTimestamp(ts, { day: 'numeric', month: 'long', year: 'numeric' });
}

export const timestampToDayMonth = (ts) => {
    if (!ts) {
        return '';
    }
    return formatTimestamp(ts, { day: '2-digit', month: '2-digit' });
}

export const isTodayTimestamp = (ts) => formatTimestamp(ts, { year: 'numeric', month: 'numeric', day: 'numeric' }) === formatTimestamp(Date.now() / 1000, { year: 'numeric', month: 'numeric', day: 'numeric' });

export const todayInUserTimeZone = () => {
    const parts = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: userTimeZone() }).formatToParts(new Date());
    const part = (type) => Number(parts.find((item) => item.type === type).value);
    return new Date(part('year'), part('month') - 1, part('day'));
}

export const secondsToTime = (seconds, propertys = {}) => {
    const {format = "mm:ss"} = propertys;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
  
    const timeArray = [
      format === "hh:mm:ss" ? hours.toString().padStart(2, '0') : null,
      minutes.toString().padStart(2, '0'),
      secs.toString().padStart(2, '0')
    ];
  
    // Filter out any null values and join the remaining values with ':'
    return timeArray.filter(Boolean).join(':');
  }